import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import styles from './Result.module.css';
import { SuccessView } from './SuccessView';
import { FailureView } from './FailureView';
import { Button } from '#/components/Button';
import { useAuth } from '#/utils/auth/useAuth';
import { useLoginRequired } from '#/utils/auth/useLoginRequired';
import {
  isStudent,
  getHighschool,
  getSchoolDisplayName,
  getStudentNumber,
  getLoginEmail,
  getSchoolEmail,
} from '#/lib/claims';

export function Result() {
  const navigate = useNavigate();
  const { error, isLoading, isAuthenticated, claims, logout } = useAuth();
  useLoginRequired(useCallback(() => navigate('/'), [navigate]));

  if (isLoading) {
    return <p className={styles.loading}>読み込み中...</p>;
  }
  // /result は Auth0 コールバックの戻り先でもある。認証/設定エラー時は空白にせず安全な表示をする。
  if (error) {
    return (
      <div className={styles.card} role="alert">
        <h1 className={styles.errorTitle}>ログインの確認中にエラーが発生しました</h1>
        <p className={styles.errorDescription}>
          お手数ですが、もう一度ログインをお試しください。解決しない場合はヘルプをご確認ください。
        </p>
        <Button variant="primary" onClick={() => void logout()}>
          もう一度ログインを試す
        </Button>
      </div>
    );
  }
  if (!isAuthenticated || !claims) {
    return null;
  }

  if (isStudent(claims)) {
    return (
      <SuccessView
        schoolName={getSchoolDisplayName(getHighschool(claims)) ?? ''}
        studentNumber={getStudentNumber(claims) ?? ''}
        schoolEmail={getSchoolEmail(claims) ?? ''}
        onLogout={() => void logout()}
      />
    );
  }
  return <FailureView loginEmail={getLoginEmail(claims)} onRetry={() => void logout()} />;
}
